import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { formConsumer, Field, GroupedMultiSelect } from 'core/form';
import { Box } from 'core/components';
import { BaseAgentRenderer } from 'app/views/synthetics/components/AgentRenderer';

function agentOptionFormatter(opts) {
  const { key, className, selected, selectItem, style, disabled, ...agent } = opts;
  return (
    <Box ml={1} key={key || agent.value}>
      <BaseAgentRenderer {...agent} locationInfoProps={{ ellipsis: true }} showLocationInfo small />
    </Box>
  );
}

@formConsumer
@observer
class AgentSelectorCompact extends Component {
  render() {
    const {
      agentOptions,
      mb = '12px',
      showLabel = true,
      disabled = false,
      large = false,
      maxItems,
      onClose
    } = this.props;
    return (
      <Field
        name="selectedAgents"
        options={agentOptions}
        small={!large}
        large={large}
        showLabel={showLabel}
        mb={mb}
        disabled={disabled}
      >
        <GroupedMultiSelect
          unselectedGroupName="agent"
          optionFormatter={agentOptionFormatter}
          maxItems={maxItems}
          onClose={onClose}
          fill
        />
      </Field>
    );
  }
}

export default AgentSelectorCompact;
